import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import { isMobile } from '../../../hooks/detect'
import globeImg from '../../../assets/globe/acr2.png'
import { SphereGeometry, MeshBasicMaterial, Material, Mesh } from 'three'
import Globe from 'globe.gl'
import './index.scss'
import capitals from '../../../mocks/capitals'
import { getRoutes } from '../../../mocks/routes'

const Globus = observer(() => {
  const ref = useRef<any>(false)
  const [width, setWidth] = useState(window.innerWidth)

  const makePoint = (d: any) => {
    const title = d.country.includes('Ukraine')
      ? 'Kyiv'
      : d.country.includes('United Kingdom')
      ? 'London'
      : 'New York'

    const text = d.country.includes('Ukraine')
      ? 'Headquarters'
      : d.country.includes('United Kingdom')
      ? 'Research and development'
      : 'Business development'

    let svg = d.country.includes('Ukraine')
      ? `<svg viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.5" y1="11" x2="0.5" y2="26" stroke="white" stroke-opacity="0.3"/>
<g clip-path="url(#clip0_208_1102)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.05143H21V0H0V7.05143Z" fill="#156DD1"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 14.0002H21V6.94873H0V14.0002Z" fill="#FFD948"/>
</g>
<defs>
<clipPath id="clip0_208_1102">
<rect width="21" height="14" rx="2" fill="white"/>
</clipPath>
</defs>
</svg>
`
      : d.country.includes('United Kingdom')
      ? `<svg  viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.5" y1="11" x2="0.499999" y2="25" stroke="white" stroke-opacity="0.3"/>
<g clip-path="url(#clip0_208_1102)">
<path d="M19.9255 -0.29834H-0.0546875V14.5121H19.9255V-0.29834Z" fill="#0A17A7"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M-0.969548 -1.71533L7.55532 4.25549V-1.28329H12.3089V4.25549L20.8338 -1.71533L21.8994 -0.082212L15.1561 4.63569H19.918V9.56961H15.1561L21.8994 14.2875L20.8338 15.9206L12.3089 9.94981V15.4886H7.55532V9.94981L-0.969548 15.9379L-2.03516 14.3048L4.70815 9.5869H-0.0537899V4.65297H4.70815L-2.03516 -0.082212L-0.969548 -1.71533Z" fill="white"/>
<path d="M13.2656 4.39369L22.2983 -1.77588" stroke="#DB1F35" stroke-width="1.33" stroke-linecap="round"/>
<path d="M14.2227 9.84619L22.3229 15.5146" stroke="#DB1F35" stroke-width="1.33" stroke-linecap="round"/>
<path d="M5.65698 4.37616L-2.79297 -1.53418" stroke="#DB1F35" stroke-width="1.33" stroke-linecap="round"/>
<path d="M6.57273 9.77686L-2.79297 16.2229" stroke="#DB1F35" stroke-width="1.33" stroke-linecap="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M-0.0546875 8.59309H8.50348V14.5207H11.359V8.59309H19.9255V5.62928H11.359V-0.29834H8.50348V5.62928H-0.0546875V8.59309Z" fill="#E6273E"/>
</g>
<defs>
<clipPath id="clip0_208_1102">
<rect width="20" height="14" rx="2" fill="white"/>
</clipPath>
</defs>
</svg>

`
      : `<svg viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.5" y1="11.25" x2="0.5" y2="26.25" stroke="white" stroke-opacity="0.3"/>
<g clip-path="url(#clip0_208_1102)">
<path d="M21 0H0V15H21V0Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 0H0V0.997666H21V0ZM21 2.00408H0V3.00175H21V2.00408ZM0 3.99942H21V4.99708H0V3.99942ZM21 6.0035H0V7.00117H21V6.0035ZM0 7.99883H21V8.9965H0V7.99883ZM21 10.0029H0V11.0006H21V10.0029ZM0 11.9983H21V12.9959H0V11.9983ZM21 14.0023H0V15H21V14.0023Z" fill="#D02F44"/>
<path d="M9.00375 0H0V7.00117H9.00375V0Z" fill="#46467F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.49875 2.00401C1.77875 2.00401 1.9975 1.77648 1.9975 1.50518C1.9975 1.23389 1.77 1.00635 1.49875 1.00635C1.2275 1.00635 1 1.23389 1 1.50518C1 1.77648 1.2275 2.00401 1.49875 2.00401Z" fill="url(#paint0_linear_208_1102)"/>
<path d="M3.49875 1.99522C3.7742 1.99522 3.9975 1.77189 3.9975 1.49639C3.9975 1.22089 3.7742 0.997559 3.49875 0.997559C3.2233 0.997559 3 1.22089 3 1.49639C3 1.77189 3.2233 1.99522 3.49875 1.99522Z" fill="url(#paint1_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.00141 1.49639C6.00141 1.77644 5.77391 1.99522 5.50266 1.99522C5.23141 1.99522 5.00391 1.76769 5.00391 1.49639C5.00391 1.2251 5.23141 0.997559 5.50266 0.997559C5.77391 0.997559 6.00141 1.2251 6.00141 1.49639Z" fill="url(#paint2_linear_208_1102)"/>
<path d="M7.49875 1.99522C7.7742 1.99522 7.9975 1.77189 7.9975 1.49639C7.9975 1.22089 7.7742 0.997559 7.49875 0.997559C7.2233 0.997559 7 1.22089 7 1.49639C7 1.77189 7.2233 1.99522 7.49875 1.99522Z" fill="url(#paint3_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.00141 2.50274C3.00141 2.78279 2.77391 3.00157 2.50266 3.00157C2.23141 3.00157 2.00391 2.77403 2.00391 2.50274C2.00391 2.23144 2.23141 2.00391 2.50266 2.00391C2.77391 2.00391 3.00141 2.23144 3.00141 2.50274Z" fill="url(#paint4_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.49875 3.00157C4.77875 3.00157 4.9975 2.77403 4.9975 2.50274C4.9975 2.23144 4.77 2.00391 4.49875 2.00391C4.2275 2.00391 4 2.23144 4 2.50274C4 2.77403 4.2275 3.00157 4.49875 3.00157Z" fill="url(#paint5_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.9975 2.50274C6.9975 2.78279 6.77 3.00157 6.49875 3.00157C6.2275 3.00157 6 2.77403 6 2.50274C6 2.23144 6.2275 2.00391 6.49875 2.00391C6.77 2.00391 6.9975 2.23144 6.9975 2.50274Z" fill="url(#paint6_linear_208_1102)"/>
<path d="M7.49875 3.99913C7.7742 3.99913 7.9975 3.7758 7.9975 3.5003C7.9975 3.2248 7.7742 3.00146 7.49875 3.00146C7.2233 3.00146 7 3.2248 7 3.5003C7 3.7758 7.2233 3.99913 7.49875 3.99913Z" fill="url(#paint7_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.00141 3.5003C6.00141 3.78034 5.77391 3.99913 5.50266 3.99913C5.23141 3.99913 5.00391 3.77159 5.00391 3.5003C5.00391 3.229 5.23141 3.00146 5.50266 3.00146C5.77391 3.00146 6.00141 3.229 6.00141 3.5003Z" fill="url(#paint8_linear_208_1102)"/>
<path d="M3.49875 3.99962C3.7742 3.99962 3.9975 3.77628 3.9975 3.50079C3.9975 3.22529 3.7742 3.00195 3.49875 3.00195C3.2233 3.00195 3 3.22529 3 3.50079C3 3.77628 3.2233 3.99962 3.49875 3.99962Z" fill="url(#paint9_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.00141 3.50079C2.00141 3.78083 1.77391 3.99962 1.50266 3.99962C1.23141 3.99962 1.00391 3.77208 1.00391 3.50079C1.00391 3.22949 1.23141 3.00195 1.50266 3.00195C1.77391 3.00195 2.00141 3.22949 2.00141 3.50079Z" fill="url(#paint10_linear_208_1102)"/>
<path d="M2.50266 4.99718C2.77811 4.99718 3.00141 4.77384 3.00141 4.49834C3.00141 4.22285 2.77811 3.99951 2.50266 3.99951C2.2272 3.99951 2.00391 4.22285 2.00391 4.49834C2.00391 4.77384 2.2272 4.99718 2.50266 4.99718Z" fill="url(#paint11_linear_208_1102)"/>
<path d="M4.49875 4.99718C4.7742 4.99718 4.9975 4.77384 4.9975 4.49834C4.9975 4.22285 4.7742 3.99951 4.49875 3.99951C4.2233 3.99951 4 4.22285 4 4.49834C4 4.77384 4.2233 4.99718 4.49875 4.99718Z" fill="url(#paint12_linear_208_1102)"/>
<path d="M6.49875 4.99718C6.7742 4.99718 6.9975 4.77384 6.9975 4.49834C6.9975 4.22285 6.7742 3.99951 6.49875 3.99951C6.2233 3.99951 6 4.22285 6 4.49834C6 4.77384 6.2233 4.99718 6.49875 4.99718Z" fill="url(#paint13_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.9975 5.50469C7.9975 5.78474 7.77 6.00353 7.49875 6.00353C7.2275 6.00353 7 5.77599 7 5.50469C7 5.2334 7.2275 5.00586 7.49875 5.00586C7.77 5.00586 7.9975 5.2334 7.9975 5.50469Z" fill="url(#paint14_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.50266 6.00353C5.78266 6.00353 6.00141 5.77599 6.00141 5.50469C6.00141 5.2334 5.77391 5.00586 5.50266 5.00586C5.23141 5.00586 5.00391 5.2334 5.00391 5.50469C5.00391 5.77599 5.23141 6.00353 5.50266 6.00353Z" fill="url(#paint15_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.9975 5.50469C3.9975 5.78474 3.77 6.00353 3.49875 6.00353C3.2275 6.00353 3 5.77599 3 5.50469C3 5.2334 3.2275 5.00586 3.49875 5.00586C3.77 5.00586 3.9975 5.2334 3.9975 5.50469Z" fill="url(#paint16_linear_208_1102)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.49875 6.00353C1.77875 6.00353 1.9975 5.77599 1.9975 5.50469C1.9975 5.2334 1.77 5.00586 1.49875 5.00586C1.2275 5.00586 1 5.2334 1 5.50469C1 5.77599 1.2275 6.00353 1.49875 6.00353Z" fill="url(#paint17_linear_208_1102)"/>
</g>
<defs>
<linearGradient id="paint0_linear_208_1102" x1="1.49875" y1="2.00401" x2="1.49875" y2="0.997596" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint1_linear_208_1102" x1="3.49875" y1="-0.000107706" x2="3.49875" y2="-0.000107706" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint2_linear_208_1102" x1="5.50266" y1="-0.000107706" x2="5.50266" y2="-0.000107706" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint3_linear_208_1102" x1="7.49875" y1="-0.000107706" x2="7.49875" y2="-0.000107706" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint4_linear_208_1102" x1="2.50266" y1="3.00157" x2="2.50266" y2="2.00391" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint5_linear_208_1102" x1="4.49875" y1="3.00157" x2="4.49875" y2="2.00391" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint6_linear_208_1102" x1="6.49875" y1="3.00157" x2="6.49875" y2="2.00391" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint7_linear_208_1102" x1="7.49875" y1="3.99913" x2="7.49875" y2="3.00146" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint8_linear_208_1102" x1="5.50266" y1="3.99913" x2="5.50266" y2="3.00146" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint9_linear_208_1102" x1="3.49875" y1="3.99962" x2="3.49875" y2="3.00195" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint10_linear_208_1102" x1="-0.0023438" y1="3.99962" x2="0.872821" y2="3.0021" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint11_linear_208_1102" x1="2.50266" y1="4.99718" x2="2.50266" y2="3.99951" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint12_linear_208_1102" x1="4.49875" y1="4.99718" x2="4.49875" y2="3.99951" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint13_linear_208_1102" x1="6.49875" y1="4.99718" x2="6.49875" y2="3.99951" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint14_linear_208_1102" x1="7.49875" y1="6.00353" x2="7.49875" y2="4.99711" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint15_linear_208_1102" x1="5.50266" y1="6.00353" x2="5.50266" y2="4.99711" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint16_linear_208_1102" x1="3.49875" y1="6.00353" x2="3.49875" y2="4.99711" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<linearGradient id="paint17_linear_208_1102" x1="1.49875" y1="5.00586" x2="1.49875" y2="6.00353" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#F0F0F0"/>
</linearGradient>
<clipPath id="clip0_208_1102">
<rect width="21" height="15" rx="2" fill="white"/>
</clipPath>
</defs>
</svg>
`
    return `
       <div class="locator-point">
         <div class='locator-point__icon'> ${svg}</div>
          <div class='locator-point__title'>${title} </div>
          <div class='locator-point__text'>${text}</div>
       </div>
        `
  }

  const changeSizesViaWidth = (width: number) => {
    return {
      width:
        width >= 2000
          ? 900
          : width > 1440 && width < 2000
          ? window.innerHeight
          : width <= 1440 && width >= 1024
          ? window.innerHeight
          : width < 1024 && width >= 768
          ? width
          : 450,
      height:
      width >= 2000
          ? 900:
        width > 1440 && width < 2000
          ? window.innerHeight
          : width <= 1440 && width >= 1024
          ? window.innerHeight
          : width < 1024 && width >= 768
          ? width
          : 450,
      minDistance: width <= 1440 ? 320 : 300,
      maxDistance: width <= 1440 ? 320 : 300,
      z: width > 1024 ? 320 : 280,
    }
  }

  useEffect(() => {
    let sizes = changeSizesViaWidth(width)

    const ARC_REL_LEN = 1
    const FLIGHT_TIME = 3000
    const NUM_RINGS = 3
    const RINGS_MAX_R = 4
    const RING_PROPAGATION_SPEED = 3

    const gData = capitals.map((c: any) => ({
      lat: c.lat,
      lng: c.lng,
      alt: Math.random() * 0.8 + 0.1,
      radius: Math.random() * 5,
      color: 'white',
      size: 0.1,
      pop: 2000000,
      country: c.country,
    }))

    const arcsData = (getRoutes() as Array<{
      startLat: number
      endLat: number
      startLng: number
      endLng: number
    }>).map((c: any) => ({
      startLat: c.startLat,
      startLng: c.startLng,
      endLat: c.endLat,
      endLng: c.endLng,
      color: '#eb1e2b',
    }))

    const globe = Globe({
      animateIn: true,
    })(document.querySelector('.intro__globe')!)
      .showAtmosphere(true)
      .atmosphereColor('#cccccc')
      .atmosphereAltitude(0.15)
      .globeImageUrl(globeImg)
      .backgroundColor('rgba(0,0,0,0)')
      .bumpImageUrl(null)
      .arcColor(() => `rgba(236, 31, 43, 0.5)`)
      .arcDashLength(ARC_REL_LEN)
      .arcDashGap(2)
      .arcStroke(0.6)
      .arcDashInitialGap(1)
      .arcDashAnimateTime(FLIGHT_TIME)
      .arcsTransitionDuration(0)
      .ringAltitude(0.015)
      .ringColor(() => (t: any) => `rgba(256,256,256,${1 - t})`)
      .ringMaxRadius(RINGS_MAX_R)
      .ringPropagationSpeed(RING_PROPAGATION_SPEED)
      .ringRepeatPeriod(2000) //(FLIGHT_TIME * ARC_REL_LEN) / NUM_RINGS
      .htmlElementsData(
        gData.filter((d: any) =>
          ['Ukraine', 'USA', 'United Kingdom'].includes(d.country),
        ),
      )
      .htmlElement((d: any) => {
        const el = document.createElement('div')
        el.innerHTML = makePoint(d)
        return el
      })
      .htmlTransitionDuration(1000)
      .objectsData(
        gData.filter(
          (d: any) => !['Ukraine', 'USA', 'United Kingdom'].includes(d.country),
        ),
      )
      .onObjectHover((e: any) => {
        const controls = globe.controls()
        if (e != null) {
          controls.autoRotate = false
        } else controls.autoRotate = true
      })
      .objectThreeObject(() => {
        const geometry = new SphereGeometry(1, 32, 16)
        const material = new MeshBasicMaterial({ color: 0xffffff })
        material.opacity = 0.7
        material.transparent = true

        const sphere = new Mesh(geometry, material)
        return sphere
      })

    const cCoords: any = { lat: 0, lng: 0, country: '' }

    const lineAnimate = (coords: any) => {
      const { startLat, startLng, endLat, endLng } = coords
      const arc = { startLat, startLng, endLat, endLng }

      globe.arcsData([...globe.arcsData(), arc])
      setTimeout(
        () => globe.arcsData(globe.arcsData().filter((d: any) => d !== arc)),
        FLIGHT_TIME * 2,
      )

      const countryCoords = capitals.find(
        (c) => c.lat == startLat && c.lng == startLng,
      )

      if (
        cCoords.lat != countryCoords?.lat &&
        cCoords.lng != countryCoords?.lng
      ) {
        cCoords.lat = countryCoords?.lat
        cCoords.lng = countryCoords?.lng
        cCoords.country = countryCoords?.country
      }

      const srcRing = { lat: startLat, lng: startLng }
      globe.ringsData([...globe.ringsData(), srcRing])

      setTimeout(() => {
        globe.ringsData(globe.ringsData().filter((r: any) => r !== srcRing))
      }, FLIGHT_TIME * ARC_REL_LEN)

      setTimeout(() => {
        const targetRing = { lat: endLat, lng: endLng }
        const endpoint = { startLat, startLng }
        const countryCoords = capitals.find(
          (c) => c.lat == endLat && c.lng == endLng,
        )
        globe.ringsData([...globe.ringsData(), targetRing])

        setTimeout(() => {
          globe.ringsData(
            globe.ringsData().filter((r: any) => r !== targetRing),
          )
        }, FLIGHT_TIME * ARC_REL_LEN)
      }, FLIGHT_TIME)
    }

    let interval = arcsData.length / 16
    setTimeout(() => {
      arcsData.forEach((a, i) => {
        setTimeout(() => {
          lineAnimate(a)
        }, FLIGHT_TIME * (i / 2))
      })
    }, 1000)

    setInterval(() => {
      arcsData.forEach((a, i) => {
        setTimeout(() => {
          lineAnimate(a)
        }, FLIGHT_TIME * (i / 2))
      })
    }, 1000 * interval + FLIGHT_TIME * interval)

    const controls = globe.controls()
    controls.rotateSpeed = 5.0
    controls.zoomSpeed = 1
    controls.enablePan = false
    controls.autoRotate = true
    controls.autoRotateSpeed = 0.4
    controls.enableZoom = false
    controls.minDistance = sizes.minDistance
    controls.maxDistance = sizes.maxDistance
    controls.minPolarAngle = Math.PI / 3.5
    controls.maxPolarAngle = Math.PI - Math.PI / 3.5

    globe.width(sizes.width)
    globe.height(sizes.height)
    let lastPoints = { lat: 0, lng: 0, altitude: 0 }
    globe.onZoom((pov: any) => {
      if (pov.altitude < 5) {
        lastPoints = {
          lat: pov.lat,
          lng: pov.lng,
          altitude: pov.altitude,
        }
        globe.pointOfView(pov)
      } else globe.pointOfView(lastPoints)
    })

    const camera = globe.camera()
    camera.aspect = 1
    camera.updateProjectionMatrix()
    camera.position.z = sizes.z
    camera.position.x = 300
    camera.position.y = 0

    function onWindowResize(e: any) {
      if (isMobile) return
      const window = e.currentTarget
      sizes = changeSizesViaWidth(width)
      controls.update()
      camera.aspect = 1
      camera.updateProjectionMatrix()
    }
    window.addEventListener('resize', onWindowResize)
    window.addEventListener('resize', () => setWidth(window.innerWidth))
    window.addEventListener('orientationchange', onWindowResize)

    document
      .querySelector('.intro__globe')
      ?.addEventListener('contextmenu', (e: any) => e.preventDefault())
  }, [width])

  return <div className="intro__globe"></div>
})

export default Globus
